'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var useWindowDimensions_hook = require('./useWindowDimensions.hook-e1e5a62f.js');
var hqoWheelPicker = require('./hqo-wheel-picker-327877b4.js');
var styles$r = require('./styles-b3bf24d6.js');

var DynamicSelect = function (_a) {
    var placeholder = _a.placeholder, dropdownItems = _a.dropdownItems, value = _a.value, label = _a.label, onSelectChange = _a.onSelectChange, pickerItems = _a.pickerItems, onPickerChange = _a.onPickerChange, doneLabel = _a.doneLabel;
    var isSmallViewport = useWindowDimensions_hook.useIsSmallViewportWidth();
    return (isSmallViewport && onPickerChange && pickerItems
        ? (React__default.createElement(styles$r.PickerContainer, null,
            React__default.createElement(hqoWheelPicker.HqoWheelPicker, { items: pickerItems, label: label, placeholder: placeholder, doneButtonLabel: doneLabel, required: true, value: value, onChange: onPickerChange })))
        : (React__default.createElement(styles$r.GeneralSelect, { value: value, titleComponent: label, placeholder: placeholder, onChange: onSelectChange, required: true }, dropdownItems.map(function (item) { return (React__default.createElement(styles$r.StyledSelectItem, { key: item, value: item, renderedValue: item })); }))));
};

exports.DynamicSelect = DynamicSelect;
